export const queryKeys = {
    ORDERS: 'orders',
    PAYIN_ORDER: 'payin_order',
    PAYIN_ORDERS: 'payin_orders',
    PAYOUT_ORDER: 'payout_order',
    PAYOUT_ORDERS: 'payout_orders',
    PAYIN_ORDERS_COUNT: 'payin_orders_count',
    PAYOUT_ORDERS_COUNT: 'payout_orders_count',
    PAYIN_TRADERS: 'payin_traders',
    PAYIN_TRADER: 'payin_trader',
    PAYOUT_TRADERS: 'payout_traders',
    PAYOUT_TRADER: 'payout_trader',
    PAYOUT_TRADER_BALANCE: 'payout_trader_balance',
    PAYOUT_TRADER_RATE: 'payout_trader_rate',
    PAYIN_TICKETS: 'payin_tickets',
    PAYOUT_TICKETS: 'payout_tickets',
    PAYOUT_CASCADES: 'payout_cascades',
    PAYOUT_CASCADE_GROUPS: 'payout_cascade_groups',
    PAYOUT_CASCADE_TEMPLATES: 'payout_cascade_templates',
} as const;
